<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'DynamicGroupedBarChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    labels: {
      type: Array,
      default: () => [],
      required: true
    },
    seriesData: {
      type: Array,
      default: () => [],
      required: true
    },
    chartTitle: {
      type: String,
      default: ''
    },
    chartKey: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    ifDefaultTheme(){
         return  process.env.VUE_APP_THEME == 0
    },
   
    colorList() { 
      return this.ifDefaultTheme ? ['#008FFB', '#f46a6a'] : ['#4f81bd', '#f46a6a'];
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          toolbar: { show: false },
        },
        title: {
          text: this.chartTitle,
          align: 'left'
        },
        plotOptions: {
          dataLabels: {
            position: 'top' 
          },
          bar: {
            horizontal: false,
            columnWidth: '55%',
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val.toString();
          },
          offsetY: -10,
          style: {
            fontSize: '12px',
            colors: ['#fff'] 
          }
        },
        xaxis: {
          categories: this.labels
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return Number.isInteger(val) ? val.toString() : '';
            }
          }
        },
        colors: this.colorList,
        legend: {
          position: 'bottom'
        }
      };
    }
  }
};
</script>
<template>
  <apexchart
    type="bar"
    height="400"
    :options="chartOptions"
    :series="seriesData"
    :key="chartKey"
  />
</template>
